import React from 'react';
import { FigureLegendPanel } from '../../core/music/vex/FigureLegendPanel';
import { EditorialFloatFigure } from '../../core/layout/EditorialFloatFigure';
import type { FigureLegendEntry } from '../../core/types/payloads/figureLegend.types';
import { ReadingRichText } from '../../core/text/readingRichText';

function stripEchoTitle(body: string, title: string): string {
  const t = String(title || '').trim();
  let next = String(body || '').trim();
  if (!t) return next;
  const norm = (s: string) =>
    s
      .replace(/\*\*/g, '')
      .replace(/^#+\s*/, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  if (norm(next) === norm(t) || norm(next) === `${norm(t)}.`) {
    return 'Lee con atención y anota una idea que puedas usar en la práctica.';
  }
  const escaped = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  next = next
    .replace(new RegExp(`^(?:\\*\\*)?${escaped}(?:\\*\\*)?\\s*:?[ \\t]*\\n+`, 'i'), '')
    .trim();
  if (norm(next) === norm(t)) {
    return 'Lee con atención y anota una idea que puedas usar en la práctica.';
  }
  return next;
}

export function InfoBlockReadView({
  payload,
}: {
  payload: {
    sectionTitle?: string;
    title?: string;
    bodyText?: string;
    imageUrl?: string;
    figureLegend?: string[];
    figureLegendEntries?: FigureLegendEntry[];
  };
}) {
  const entries = payload.figureLegendEntries ?? [];
  const legacyLegend = payload.figureLegend ?? [];
  const imageUrl = String(payload.imageUrl || '').trim() || undefined;
  const heading = payload.sectionTitle || payload.title;
  const bodyText = stripEchoTitle(String(payload.bodyText || ''), String(payload.title || ''));

  return (
    <div className="info-block-view info-block-view--editorial">
      {heading ? <h3 className="info-block-view__title">{heading}</h3> : null}
      <div className="info-block-view__flow">
        {imageUrl ? (
          <EditorialFloatFigure
            src={imageUrl}
            alt={heading || 'Ilustración'}
          />
        ) : null}
        <ReadingRichText text={bodyText} className="info-block-view__body" />
        {entries.length > 0 ? (
          <FigureLegendPanel entries={entries} />
        ) : legacyLegend.length > 0 ? (
          <div className="info-block-view__legend">
            <p className="info-block-view__legend-title">Figuras en esta obra</p>
            <ul>
              {legacyLegend.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
}
